/*
 * @Author: vinnypeng
 * @Date: 2022-04-01 14:25:37
 * @Last Modified by: vinnypeng
 * @Last Modified time: 2022-05-06 19:32:08
 */
import { post } from '../lib/http';
import { GetServerSidePropsContext } from 'next';
import { HttpPrefix } from '../lib/wemeet-http-moudle';
import { getUserInfoFromSession } from '@utils/login-util';

interface RedDotRes {
  code: number;
  message: string;
  nonce: string;
  data: any;
}

interface RedDotReq {
  corpId?: string;
  path?: string;
  ticket?: string;
  token_type?: string;
}

// 拉取红点位置列表
export const getRedDotList = async (ctx?: GetServerSidePropsContext) => {
  try {
    /* eslint-disable @typescript-eslint/naming-convention */
    const { crop_id, app_id } = getUserInfoFromSession() || {};
    const data: RedDotReq = { corpId: crop_id || app_id };
    if (window.currentTicket) {
      data.ticket = window.currentTicket;
      data.token_type = '101779933';
    }
    const dotList = await post<RedDotRes>(
      HttpPrefix.WEMEET_TAPI,
      '/v2/reddot/reddot/pull',
      data,
      ctx,
    );
    return dotList?.data;
  } catch (e) {
    console.error('request error', e);
  }
  return null;
};

// 清除红点
export const resetRedDot = async (path: string, ctx?: GetServerSidePropsContext) => {
  try {
    const data: RedDotReq = { path };
    if (window.currentTicket) {
      data.ticket = window.currentTicket;
      data.token_type = '101779933';
    }
    const res = await post<RedDotRes>(HttpPrefix.WEMEET_TAPI, '/v2/reddot/reddot/reset', data, ctx);
    return res.code === 0;
  } catch (e) {
    console.error('request error', e);
  }
  return false;
};
